export default "__VITE_ASSET__$iPispJS__"